import { OUTCOME_AWARENESS, REACH } from '../../../../../constants/campaigns'

export const getShowBudgetSection = (objective: string): boolean => {
  return objective !== OUTCOME_AWARENESS && objective !== REACH
}
